// extracted by mini-css-extract-plugin
export default {"effectsMenu":"effectsMenu__ZYA3j","effectBox":"effectBox___UpSE","active":"active__v2Iak","image":"image__B0gFm","removeBtn":"removeBtn__a7SXy","upload":"upload__DVhcP"};